import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { crudService } from "services/crud.service";
import { initialPermissionState, initialSettingState } from "store/constants";
import { getErrorMessage, getPaginatedUrlWithSearchParams } from "store/helper";
import { NotificationManager } from "react-notifications";
import { endPoints } from "utils/constants";

const { userSettingEndPoint } = endPoints;

export const fetchUserSettings = createAsyncThunk(
  "settings/fetchUserSettings",
  async ({ userId }: { userId: string }, { rejectWithValue }) => {
    try {
      const paginatedUrl = getPaginatedUrlWithSearchParams({
        pageNumber: 1,

        endpoint: userSettingEndPoint,
        searchParams: {
          user__id: userId,
        },
      });
      const response: AxiosResponse = await crudService.getAll(paginatedUrl);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateUserSettings = createAsyncThunk(
  "settings/updateUserSettings",
  async ({ updatedSettings, settingId }: any, { rejectWithValue }) => {
    try {
      const response: AxiosResponse = await crudService.update(
        userSettingEndPoint,
        settingId,
        updatedSettings
      );
      if (response.status === 204) {
        NotificationManager.success("User Setting updated Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

const userSettingSlice = createSlice({
  name: "settings",
  initialState: initialSettingState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch user settings
    builder
      .addCase(fetchUserSettings.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        fetchUserSettings.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.settings = action.payload?.objects;
          state.isDarkMode = action.payload?.objects[0]?.dark_theme;
        }
      )
      .addCase(
        fetchUserSettings.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );

    //   update user settings
    builder
      .addCase(updateUserSettings.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        updateUserSettings.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
        }
      )
      .addCase(
        updateUserSettings.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );
  },
});

export const userSettingReducer = userSettingSlice.reducer;
